import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import PensionContainer from './container/PensionContainer';

function SeniorCitizenSettingsTabContainer({ match, pathName, permissions }) {
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row border-bottom-row">
          <ul className="nav nav-tabs sub-tab-borongan">
            {Acl(permissions, ['VIEW SENIOR CITIZEN PENSION SETTINGS']) && (
              <li className="nav-item">
                <Link
                  to="/social-ameliorations/settings/senior-citizen"
                  className={`nav-link sub-tab py-3 px-5 ${pathName.indexOf(
                    '/social-ameliorations/settings/senior-citizen/pensions'
                  ) > -1
                    ? 'selected'
                    : ''
                    }`}
                >
                  Pensions
                </Link>
              </li>
            )}
            
          </ul>
        </div>
      </div>
      <Switch>
        <Route
          exact
          path={`${match.path}`}
          render={() => <Redirect to={`${match.path}/pensions`} />}
        />
        {Acl(permissions, ['VIEW SENIOR CITIZEN PENSION SETTINGS']) && (
          <Route
            path={`${match.path}/pensions`}
            component={PensionContainer}
          />
        )}
      </Switch>
    </React.Fragment>
  );
}

SeniorCitizenSettingsTabContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(SeniorCitizenSettingsTabContainer);
